import React from 'react';

import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SxProps,
} from '@mui/material';
import { KeyboardArrowDown } from '@mui/icons-material';

import { HomeBottomButtonOptionsSettingsProps } from './interfaces';
import { useStyles } from './styles';

const HomeBottomButtonOptionsSettings = ({
  devices,
  handleSelect,
  selectedValue,
  label = '',
  disabled = false,
  sx = {},
}: HomeBottomButtonOptionsSettingsProps) => {
  const classes = useStyles();

  let activeDevice = selectedValue;
  if (devices.length) {
    activeDevice = devices.find(({ deviceId }) => deviceId === selectedValue)
      ? selectedValue
      : devices[0].deviceId;
  }

  return (
    <FormControl sx={classes.root}>
      {label ? <InputLabel sx={classes.label}>{label}</InputLabel> : null}
      <Select
        label={label}
        value={activeDevice}
        onChange={handleSelect}
        disableUnderline
        variant="standard"
        sx={{ ...classes.select, ...sx } as SxProps}
        IconComponent={KeyboardArrowDown}
        disabled={disabled}
      >
        {devices.map((device: any) => (
          <MenuItem value={device.deviceId} key={device.deviceId}>
            {device.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default HomeBottomButtonOptionsSettings;
